var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.1875,
    cy: 12,
    rx: 6.46875,
    ry: 6.75,
    fill: "#E80B26"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.8125,
    cy: 12,
    rx: 6.46875,
    ry: 6.75,
    fill: "#F59D31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 17.0311C12.8234 15.7952 13.6562 13.9991 13.6562 11.9999C13.6562 10.0008 12.8234 8.20471 11.5 6.96875C10.1766 8.20471 9.34375 10.0008 9.34375 11.9999C9.34375 13.9991 10.1766 15.7952 11.5 17.0311Z",
    fill: "#FC6020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMastercard);
export default __webpack_public_path__ + "static/media/payment-mastercard.750abac26f481e5f3243c818f68805c5.svg";
export { ForwardRef as ReactComponent };